import * as React from "../_snowpack/pkg/react.js";
import {SKIP_REASON} from "./count-dates.js";
import {dayOfMonth, format, getHoliday} from "./date-helpers.js";
import {lastDayOfMonth} from "../_snowpack/pkg/date-fns.js";
import {Explanation} from "./Style.js";
export const Explanations = ({data}) => {
  if (!data.length) {
    return null;
  }
  const explanationMap = {
    [SKIP_REASON.WEEKEND]: (date) => `${dayOfMonth(date)} to ${format(date, "cccc")}`,
    [SKIP_REASON.LAST_DAY_OF_MONTH]: (date) => `Ostatni dzień ${format(date, "MMMM")} to ${dayOfMonth(lastDayOfMonth(date))}`,
    [SKIP_REASON.BANK_HOLIDAY]: (date) => {
      const holidayName = getHoliday(date)[0].name;
      return `${dayOfMonth(date)} to ${holidayName}`;
    }
  };
  const explanations = data.map(({date, reason}) => explanationMap[reason](date));
  return /* @__PURE__ */ React.createElement(Explanation, null, "Wyjaśnienie:", explanations.map((text) => /* @__PURE__ */ React.createElement("p", null, text)));
};
